import services from './../../services/service'; // Service Class
import SecondHeader from './../Second-Header/index.vue'; // Second Header
import Sidebar from './../Sidebar/index.vue'; // Sidebar
import MainFooter from './../Main-Footer/index.vue'; // Main Footer
import SearchBar from '../SearchBar.vue'; // Search Bar
let service = new services();

export default {
    name: 'BusinessSearch',
    data () {
        return {
            businesses: {},
            search: {},
            search_result: "",
            search_message: "",
            img_url: service.imageURL,
            pag_intv: service.pageIntv,
            current_page: 0,
        }
    },
    components: {
        'second-header': SecondHeader,
        'sidebar': Sidebar,
        'main-footer': MainFooter,
        'search-bar': SearchBar
    },
    
    methods: {
        //settings
        isActive(page){
            if(page == this.current_page){
                return true;
            }
        },


        getSearchBusinesses(offset,items) {
            var credentials = {
                 search_type: 'businesses',
                 search_keywords: this.$route.query.context,
                 search_city: this.$route.query.city
             }
             //this.search_result = localStorage.getItem("cityneeds_search_keywords");
             this.search_result = this.$route.query.context;
             service.searchBusinesses(this, credentials,offset,items).then(function(data) {
                if(data.body.status == 200) {
                     this.businesses = data.body.data;
                     if((data.body.data_count % this.pag_intv)){
                         this.businesses.count_range = (Math.floor(data.body.data_count/this.pag_intv)+1);
                     }else{this.businesses.count_range = Math.floor(data.body.data_count/this.pag_intv);}
                      this.current_page = items;
                    }else if(data.body.status == 400) {
                     //do something here like redirect to advertised data 
                     this.search_message = "Sorry Could not get the Information of entry yet";            
                 }else{
                     this.search_message = "Sorry Could not get the Information of entry yet"; 
                 }
             })
         },
    },
    created: function(){

        this.getSearchBusinesses(0,this.pag_intv);
    }
}


// WEBPACK FOOTER //
// ./src/components/BusinessSearch/script.js